export default {"src":"/_next/static/media/coin-circle-color.30bdfa89.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};